<div class="flex flex-col gap-10 animate-fadeIn p-6 w-full max-w-2xl">
  <div class="flex flex-col gap-1">
    <h3 class="text-xl font-bold text-slate-700 tracking-tight">{{ 'billing_tab_title' | translate }}</h3>
    <p class="text-sm text-slate-400 font-medium">{{ 'billing_tab_desc' | translate }}</p>
  </div>

  <div *ngIf="loading" class="flex justify-center items-center py-10">
    <i class="pi pi-spin pi-spinner text-primary text-2xl"></i>
  </div>

  <div *ngIf="!loading" class="flex items-center justify-between gap-4 pt-4 border-t border-slate-100">
    <div class="flex flex-col gap-1 max-w-md">
      <label class="text-sm font-semibold text-slate-500">{{ 'billing_field_partial_payout' | translate }}</label>
      <p class="text-xs text-slate-400">{{ 'billing_field_partial_payout_hint' | translate }}</p>
    </div>
    <p-toggleswitch
      [(ngModel)]="honoraryPartialPayout"
      [disabled]="isSaving || !canEdit"
      (onChange)="onPartialPayoutChange($event.checked)">
    </p-toggleswitch>
  </div>
</div>
